import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import  *  as  appsettings  from  './appsettings.json';
import { Meta, Title } from '@angular/platform-browser';

declare const io: any;
declare const $: any;
declare var window: any;
declare var google: any;
@Injectable({
  providedIn: 'root'
})

//command to add componene: ng generate component componentname

export class CommonService implements OnInit {

  public IsProd : boolean = null; //Note this is nomved. Refer to src/app/appsettings.json for setting this true or false.
  public Version = "";
  public spinner : boolean = false;
  public MAIN_URL = "";
  public SERVICE_URL = "";
  public paypalUrl = "";
  public loginSignupRedirect = '';
  public redirectTo = '';
  public NewMessageCount = 0;
  public TermsAndConditionFlag = true;
  public IsSysAdmin = false;
  public IsAdmin = false;
  public IsVolunteer = false;
  public IsMember = false;
  public IsStoreManager = false;
  public IsGardenManager = false;
  public httpOptions = {};
  public FIPS: any;
  public user: any = {};
  public showLoader: boolean = false;
  public isRegistering : boolean = false;

  public enumTable:any  = {};
  public Skills:any  = [];
  public SkillCategories:any  = [];
  public SkillCategoriesGroupByCategory : any[] = [];  
  //public Pictures : any[] = [{imageSrc:'/assets/images/ogimage.jpg', link:'/about'}];  
  public Pictures : any[] = [{imageSrc:'https://content.rishiyog.org/Events/November/RishiGarden.png', link:'/store'}];  

  public eventData : any= [];
  public activeEvents : any= [];
  public upcomingEvents : any= [];
  public memberUpcomingEvents : any= [];
  public chapterUpcomingEvents : any= [];
  public regionalUpcomingEvents : any= [];
  public globalUpcomingEvents : any= [];
  public pastEvents : any= [];
  public topProducts : any= [];
  public topActiveEvent : any;
  public showMoreEvents: boolean = false;
  public contentData : any= [];
  public blogs : any= [];
  public showMoreBlogs: boolean = false;

  constructor(public http: HttpClient,private router : Router, private _snackBar: MatSnackBar, private title: Title, private meta: Meta) {

    var appsettingsData : any = {};
    appsettingsData = appsettings;
    if(appsettingsData != null && appsettingsData.default != null && appsettingsData.default.Data  != null && appsettingsData.default.Data.IsProd != null){
      var IsProd = appsettingsData.default.Data.IsProd;
      if(IsProd == 'true'){
        this.IsProd = true;
      }
      else {
        this.IsProd = false;           
      }
    }

    var protocol = 'https:';
    //var protocol = 'http:';
    if(this.IsProd == true){
      this.MAIN_URL = protocol + "//api.rishiyog.org";
      this.paypalUrl = "https://api.paypal.com/v1";
    }
    else{
      this.MAIN_URL =  protocol + "//localhost:5001";
      this.paypalUrl = "https://api.sandbox.paypal.com/v1";
    }
    this.SERVICE_URL = this.MAIN_URL + "/api";

    this.ngOnInit();

    this.refreshUser(null);
  }

  updateTitle(title: string) {
    this.title.setTitle(title);
    this.meta.updateTag({ name: 'og:title', content: title })
  }

  updateOgUrl(url: string) {
    this.meta.updateTag({ name: 'og:url', content: location.origin + url })
  }

  updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc })
    this.meta.updateTag({ name: 'og:description', content: desc })    
  }

  updateImage(image: string) {
    this.meta.updateTag({ name: 'og:image', content: image })
  }

  getRandColor(id){
    var letters = 'ACBFED0192837465';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor((id + i) % 16)];
    }
    return color;
  }

  utcStringToLocalString = function (utsStringDt){
    return utsStringDt.split("T")[0];
  }

  utcSecondsToLocal = function (utcSeconds){
    var utcTime = new Date(Date.UTC(1970, 0, 1, 0, 0, 0));
    var localTime = new Date(utcTime.getTime() + utcSeconds * 1000); 
    return localTime;
  }

  localToUtcSeconds = function (localDate){
    return localDate/1000;
  }

  groupBy(xs, prop) {
    var grouped = [];
    var groupedArray : any[] = []; 
    for (var i=0; i<xs.length; i++) {
      var p = xs[i][prop];
      if (!grouped[p]) { grouped[p] = []; }
      grouped[p].push(xs[i]);
    }
    for(var Category in grouped) {
      var CategoryItems = grouped[Category]; 
      groupedArray.push({Category, CategoryItems});
    }

    return groupedArray;
  }

  readEnums(){
    return new Promise((resolve, reject) => {
      this.request('/public/allenums', 'get', {}, false).then((response: any) => {
        if(response.Status == 200){
          if(response.Data != null) {
            this.enumTable = response.Data.enumTable;
            this.SkillCategories = response.Data.SkillCategories.filter(item => item.Status == 1);
            var tempSkills = [];
            this.SkillCategories.forEach(function (category) { 
              var catItems = response.Data.Skills.filter(item => item.Category == category.Name);
              catItems.forEach(function (catItem) { 
                tempSkills.push(catItem);
              });
            });
            this.Skills = tempSkills;
            this.SkillCategoriesGroupByCategory  = this.groupBy(this.Skills, 'Category');
            resolve(true);
          }
          this.readEvents();
          this.readTopProducts();
        }
      }).catch((err) => {
      });
    });
  }

  readEvents(){
    this.request('/public/events', 'get').then((res: any) => {
      if (res.Status == 200) {
        var currentDate = new Date();
        currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        this.eventData = res.Data;
        //this.upcomingEvents = this.eventData.filter(item => new Date(item.EventDateTime) >= currentDate );
        this.activeEvents = this.eventData.filter(item => this.enumTable.EventStatus[item.Status].Value == this.enumTable.EventStatus.filter(s => s.Value == 'Active')[0].Value );
        if(this.activeEvents != null && this.activeEvents.length > 0){
          this.topActiveEvent = this.activeEvents[0];
        }

        for (let index = 0; index < this.activeEvents.length; index++) {
          const event = this.activeEvents[index];
          var link = '/search/event/' + event.Id;
          var imageSrc = event.Picture.trim();
          const Pictures = event.Picture.split(',');
          if(Pictures && Pictures.length > 0){
            imageSrc = Pictures[0].trim();
          }
          this.Pictures.push({imageSrc, link});  
        }       
        this.memberUpcomingEvents = this.eventData.filter(item => this.enumTable.EventType[item.Type].Value == 'Member' && new Date(item.EventDateTime) >= currentDate );
        this.chapterUpcomingEvents = this.eventData.filter(item => this.enumTable.EventType[item.Type].Value == 'Chapter' && new Date(item.EventDateTime) >= currentDate );
        this.regionalUpcomingEvents = this.eventData.filter(item => this.enumTable.EventType[item.Type].Value == 'Regional' && new Date(item.EventDateTime) >= currentDate );
        this.globalUpcomingEvents = this.eventData.filter(item => this.enumTable.EventType[item.Type].Value == 'Global' && new Date(item.EventDateTime) >= currentDate );

        this.pastEvents = this.eventData.filter(item =>{
          const itemDateOnly = new Date(item.timestamp.getFullYear(), item.timestamp.getMonth(), item.timestamp.getDate());
          return itemDateOnly.getTime() === currentDate.getTime();
        }).sort(function(a, b) {
          if( new Date(b.EventDateTime) >= new Date(a.EventDateTime)) return 1;
          return -1;
        });

        if(this.pastEvents.length > 3){
          this.showMoreEvents = true;
          this.pastEvents = this.pastEvents.slice(0, 3);
        }
        this.request('/public/contentsbylocation?location=0', 'get').then((res: any) => {
          if (res.Status == 200) {
            this.contentData = res.Data;
          }
          /* else {
            this.error = res.Message;
          }*/
        }).catch((err) => {
        });
      } /*else {
        this.error = res.Message;
      }*/
    }).catch((err) => {
    });

    this.request('/public/blogs', 'get').then((res: any) => {
      if (res.Status == 200) {
        this.blogs = res.Data;
        if(this.blogs.length > 3){
          this.showMoreBlogs = true;
          this.blogs = this.blogs.slice(0, 3);
        }

      } /* else {
        this.error = res.Message;
      }*/
    }).catch((err) => {
    });
  }

  readTopProducts(){
    this.request('/public/products?keyword=0', 'get').then((res: any) => {
      if (res.Status == 200) {
        this.topProducts = res.Data;
      } 
    }).catch((err) => {
    });
  }
 
  async ngOnInit() {
    this.readEnums();
    /*
    try {
      this.http.get('https://rishiyog.org/version.txt', {responseType: 'text'})
      .subscribe((res: any) => {
        this.Version = res;
      });
    }catch (err) {
      console.log(err);
    }
    */
  }


  UpdateRedirection(res){
    this.NewMessageCount = 0;
    if(res != null && res.responseData != null && res.responseData.NewMessageCount != null){
      this.NewMessageCount = res.responseData.NewMessageCount;
    }
    if(this.user.UserData.IsProvider == 'No' && this.user.UserData.RegisterUserType == 1) {
      this.isRegistering = true;
      if(res != null){
        document.cookie = "NewMessageCount=" + this.NewMessageCount.toString() + "; expires=" + res.responseData.AuthDetails.expires;     
        document.cookie = "TermsAndConditionFlag=" + this.TermsAndConditionFlag.toString() + "; expires=" + res.responseData.AuthDetails.expires;     
                
      }
      if(this.user.UserData.ProviderFormStage == 1){
        this.loginSignupRedirect = 'settings/servicesoffered';
      }
      if(this.user.UserData.ProviderFormStage == 2){
          this.loginSignupRedirect = 'settings/businessdetails';
      }
      if(this.user.UserData.ProviderFormStage == 3){
        if(this.user.UserData.ProviderPicture == null || this.user.UserData.ProviderPicture == ''){
          this.loginSignupRedirect = 'settings/updatephoto';
        } else {
          this.loginSignupRedirect = 'settings/editprofile';     
        }
      }
    }else{
      if(this.loginSignupRedirect != null && this.loginSignupRedirect != ''){
        return 0;
      }
      else{
        if(this.user.UserData.UserType != 1 && this.user.UserData.ProviderFormStage == 4){
          if(res != null){
            this.request('/Orders/GetSyncOrders_1?unixTimeStamp=0&ftype=', 'get').then((res: any) => {
              var pendingItems = res.responseData.filter(item => item.Status === 2);
              if(pendingItems && pendingItems.length > 0){
                this.loginSignupRedirect = 'dashboard'
              }else{
                this.loginSignupRedirect = 'settings/productsoffering';
              }
              this.router.navigateByUrl('/' + this.loginSignupRedirect);
            }).catch((err) => {
            });
          }
        }
        else{
          if(this.user.UserData.UserType != 1){
            this.loginSignupRedirect = 'dashboard';   
          }
          else{
            if(this.NewMessageCount != null && this.NewMessageCount > 0){
              this.loginSignupRedirect = 'dashboard/messages';   
            }
            else{
              this.loginSignupRedirect = '';   
            }
          }       
        }
      }
    }
    return this.user.UserData.ProviderFormStage;
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  delete_cookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  getUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  request(url, type, data: any = {}, showSpinner = true) {
    this.spinner = showSpinner;
    return new Promise((resolve, reject) => {
      if (type == 'post' || type == 'put' || type == 'patch') {
        data.dbVersion = 7;
        this.http[type](this.SERVICE_URL + url, data, this.httpOptions)
          .subscribe(res => {
            if(showSpinner == true){
              this.spinner = false;                   
            }       
            if(res.authentication != null && res.authentication == false){
              if(res.message != null && res.message != ''){
                this._snackBar.open(res.message, "", {duration: 2000,});
              }
              this.logout();             
            }
            resolve(res);
          })
      }
      else {
        if (data != null) {
          url += "?"
          for (let key in data) {
            url += `${key}=${data[key]}&`
          }
          url = url.substring(0, url.length - 1)
        }
        this.http[type](this.SERVICE_URL + url, this.httpOptions)
          .subscribe(res => {
            if(showSpinner == true){
              this.spinner = false;                   
            }   
            if(res.authentication != null && res.authentication == false){
              if(res.message != null && res.message != ''){
                this._snackBar.open(res.message, "", {duration: 2000,});
              }
              this.logout();             
            }
            resolve(res);
          })
      }
    })
  }

  login(auth: any = {}) {
    return new Promise((resolve, reject) => {
      var type = 'post';
        this.http[type](this.MAIN_URL + '/api/applicationuser/login', auth)
          .subscribe(
            (            res: unknown) => resolve(res),
            (            error: any) => reject(error)
            );
    })
  } 

  paypalRequest(url, type, data: any = {}, headers) {
    let httpOptions = {
      headers: new HttpHeaders(headers)
    }
    return new Promise((resolve, reject) => {
      if (type == 'post' || type == 'put' || type == 'patch') {
        this.http[type](url, data, httpOptions)
          .subscribe(
            res => resolve(res),
            error => reject(error)
            )}
      else {
        this.http[type](url, httpOptions)
          .subscribe(
            res => resolve(res),
            error => reject(error)
          )
      }
    })
  }

  outsideRequest(url, type, data: any = {}) {
    return new Promise((resolve, reject) => {
      if (type == 'post' || type == 'put' || type == 'patch') {
        this.http[type](url, data)
          .subscribe(res => {
            resolve(res);
          })
      }
      else {
        this.http[type](url)
          .subscribe(res => {
            resolve(res);
          })
      }
    })
  }

  refreshUser(data) {
    if (data) {
      this.user = data.UserData;  
      this.user.access_token = data.token;
      this.user.expiration = data.expiration;
      this.IsSysAdmin = this.user.Roles.findIndex(reader => reader === 'SysAdmin') > -1;
      this.IsAdmin = this.user.Roles.findIndex(reader => reader === 'Admin') > -1;
      this.IsVolunteer = this.user.Roles.findIndex(reader => reader === 'Volunteer') > -1;
      this.IsMember = this.user.Roles.findIndex(reader => reader === 'Member') > -1;
      this.IsStoreManager = this.user.Roles.findIndex(reader => reader === 'StoreManager') > -1;
      this.IsGardenManager = this.user.Roles.findIndex(reader => reader === 'GardenManager') > -1;

    } else {
      this.user = {};
    }
    this.refreshHttpOptions();
    this.readData();
  }

  readData(){
    if (this.user.access_token) {
      this.request('/applicationuser', 'get').then((res: any) => {
        if (res.Status == 200) {
          this.user.data = res.Data;
          this.user.data.IsVolunteer = this.IsVolunteer;
          this.user.data.DateOfBirthDisplay = new Date(this.user.user.DOB);
        }
      }).catch((err) => {
      })
    }
  }

  getTimeArr() {
    var x = 30; //minutes interval
    var times = []; // time array
    var tt = 0; // start time
    var ap = [' am', ' pm']; // AM-PM

    for (var i = 0; tt < 24 * 60; i++) {
      var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
      var mm = (tt % 60); // getting minutes of the hour in 0-55 format
      times[i] = {value:tt, display:("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh / 12)]}; // pushing data in array in [00:00 - 12:00 AM/PM format]
      tt = tt + x;
    }
    let finalTimes = times.splice(0, 18);
    times = times.concat(finalTimes);
    var index = times.indexOf('00:30 pm');
    if (~index) {
      times[index] = '12:30 pm';
    }
    return times;
  }
  
  loginSuccess(data) {
    try {
      try {
        document.cookie = "access_token=" + data.Data.token + "; expires=" + data.Data.expiration;
        document.cookie = "NewMessageCount=" + this.NewMessageCount.toString() + "; expires=" + data.Data.expiration;   
        document.cookie = "UserData=" + data.Data.UserData + "; expires=" + data.Data.expiration;
      } catch (err) {
        console.log(err);
      }
      this.refreshUser(data.Data);
      if(this.loginSignupRedirect != null && this.loginSignupRedirect != ''){
        this.redirectTo = this.loginSignupRedirect;
        this.loginSignupRedirect = '';
        this.router.navigateByUrl('/' + this.redirectTo, { state: { reload: true } });
      }else{
        this.router.navigateByUrl('/' + data.Data.redirectTo, { state: { reload: true } });
      }
    } catch (err) {
      console.log(err);
    }
  }

  logout() {
    this.delete_cookie('access_token');
    this.delete_cookie('SecurityStamp');
    this.delete_cookie('FirstName');
    this.delete_cookie('LastName');
    this.delete_cookie('UserName');
    this.delete_cookie('PhoneNumber');
    this.delete_cookie('ApplicationUserId');
    this.delete_cookie('UserType');
    this.delete_cookie('CompanyFOStatus');
    this.delete_cookie('UserSetting');
    this.delete_cookie('UserData');
    this.delete_cookie('isRegistering');    
    this.delete_cookie('NewMessageCount');    
    this.delete_cookie('TermsAndConditionFlag');    
    localStorage.clear();
    this.refreshUser(null);
    this.TermsAndConditionFlag = false;
    this.router.navigateByUrl('/login', { state: { reload: true } });

  }
  refreshHttpOptions() {
    let options: any = {};
    if (this.user.access_token) {
      options.Authorization = "Bearer " + this.user.access_token
      options.SecureStamp = this.user.SecurityStamp
    }
    this.httpOptions = {
      headers: new HttpHeaders(options)
    };
  }

  mobilecheck = function () {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };

  isIos() {
    let ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    return ios;
  }

  isIphone4() {
    let value = navigator.userAgent.match(/iPhone/i) !== null && window.screen.height == (960 / 2);
    return value;
  }

  getDummyArray(length: number) {
    if(length == null){
      length = 0;
    }
    return Array(Math.round(length));
  }

  decideAmPm(hours, minutes = '00') {
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours || 12;
    minutes = '00'
    return hours + ':' + minutes + ' ' + ampm;
  }

  GetCardType(number) {
    var re = new RegExp("^4");
    if (number.match(re) != null)
      return "Visa";

    re = new RegExp("^(34|37)");
    if (number.match(re) != null)
      return "American Express";

    re = new RegExp("^5[1-5]");
    if (number.match(re) != null)
      return "MasterCard";

    if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
      return "Mastercard";

    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null)
      return "Discover";


    return "";
  }

  isInteger(number) {
    if (Number.isInteger(number)) {
      return '.00';
    } else {
      return '';
    }
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  absolute(n){
    return(Math.abs(n));
  }

  trimText(input, length){
    if (input.length > length) {
      return input.substring(0, length-3) + '...';
   }
   return input;
  }

  togglePopup(myImg){
    var modal = document.getElementById("ImageModal");
    var modalImg = document.getElementById("ImageModalPicture");
    modal.style.display = "block";
    modalImg.setAttribute( 'src', myImg);
  }

  formatTime(hour){
    if (hour == 12){
      return('12 PM');
    }
    
    if (hour == 24 || hour == 0){
      return('12 AM');
    }

    var hh=' PM';
    if (hour >=0 && !(hour >= 12)){
      hh = ' AM';
    }else{
      hour = hour - 12;
    }

    var retHour = hour.toString();
    if(hour < 10){
      retHour = '0' + retHour;
    }
    return(retHour + ":00" +hh);
  }
}
